require('./builders/openable_element_builder.ts');
require('./builders/self_alert_course_builder.ts');
require('./builders/self_alert_reason_builder.ts');
require('./commands/close_openable_element_command.ts');
require('./commands/get_self_alert_data_command.ts');
require('./commands/get_stc_configs_command.ts');
require('./commands/load_priority_feed_data_command.ts');
require('./commands/load_pronouns_command.ts');
require('./commands/submit_self_alert_command.ts');
require('./commands/submit_student_feedback_command.ts');
require('./components/account_avatar/account_avatar.ts');
require('./components/app_support/app_support.ts');
require('./components/feed_container/feed_container.ts');
require('./commands/load_kb_name_command.ts');
require('./commands/load_self_alert_icon_details_command.ts');
require('./commands/init_openable_elements_command.ts');
require('./commands/open_openable_element_command.ts');
require('./components/personal_greeting/personal_greeting.ts');
require('./components/priority_feed_components_module.ts');
require('./components/quick_add/quick_add.ts');
require('./components/self_alert_dialog/self_alert_dialog.ts');
require('./configuration.ts');
require('./datasources/self_alert_course_datasource.ts');
require('./datasources/self_alert_reasons_datasource.ts');
require('./datasources/openable_elements_datasource.ts');
require('./models/knowledge_bot_model.ts');
require('./models/pronouns_model.ts');
require('./models/self_alert_term_model.ts');
require('./models/self_alert_icon_details_model.ts');
require('./models/stcconfigs_model.ts');
require('./queries/knowledge_bot_query.ts');
require('./queries/pronouns_query.ts');
require('./queries/self_alert_dialog_query.ts');
require('./queries/self_alert_icon_details_query.ts');
require('./queries/openable_elements_query.ts');
require('./queries/sum_badge_count_query.ts');
require('./routes.ts');
require('./views/priority_feed/priority_feed.ts');
require('./views/views_module.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/core.ts